import { fetchAvailabilityDateRange } from 'actions/CalendarActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import getObjectKey from 'lib/object/getObjectKey'

/**
 * Fetches availability whenever checkInDate/duration are set. Occupancy is derived from
 * rooms with a stable key so non-occupancy room fields don't trigger refetches.
 */
export function useAvailabilityForDate(
  offerId: string | undefined,
  rooms: Array<App.Occupants>,
  checkInDate: string | undefined,
  duration: number | undefined,
  lereGroup?: string,
): void {
  const dispatch = useAppDispatch()
  const occupancyKey = getObjectKey({ rooms })

  useEffect(() => {
    if (!offerId || !checkInDate || !duration) return
    dispatch(
      fetchAvailabilityDateRange({
        offerId,
        date: checkInDate,
        nights: duration,
        rooms,
        lereGroup,
      }),
    )
  },
  // NB: occupancyKey intentionally covers rooms so this effect does not rerun
  // when non-occupancy room fields (e.g. roomId) change.
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  [offerId, checkInDate, duration, occupancyKey, lereGroup, dispatch],
  )
}
